export default function ContactSectionOne () {

    const DisplayMessage = () => {
        alert("Please Contact us via phone or email for now, the team is currently updating this form");
    }

    const contactInfo = [
        {
            "contact_name": "Karenann Carty",
            "contact_position": "President",
            "contact_number": "123-456-7890",
            "contact_email": "kcarty@monroecollege.edu"
        },
    
        {
            "contact_name": "Denise Link",
            "contact_position": "Vice President",
            "contact_number": "123-456-7890",
            "contact_email": "dlink@wlsmail.org"
        },
    
        {
            "contact_name": "Edward Castro",
            "contact_position": "Secretary",
            "contact_number": "123-456-7890",
            "contact_email": "ecastro@nreadlearn.org"
        },
    
        {
            "contact_name": "Millicent Lee",
            "contact_position": "Treasurer",
            "contact_number": "123-456-7890",
            "contact_email": "mlee@nreadlearn.org"
        }
    ];

    return (
        <section className="bg-gray-50">
            <div className="lg:py-12 py-4 max-w-6xl mx-auto flex flex-col lg:gap-12 gap-6">

                <h2 className="text-5xl text-center">Contact us</h2>

                <div className="p-2 lg:grid lg:grid-cols-2 lg:gap-6 flex flex-col gap-2 text-lg">
                    {contactInfo.map((contact, index) => (
                        <div key={index} className="border py-6 px-8 flex flex-col gap-1 lg:shadow-md">
                            <p className="font-bold text-md">{contact.contact_position}</p>
                            <p className="italic text-gray-400">{contact.contact_name}</p>
                            <a href={`mailto:${contact.contact_email}`} className="font-medium text-sm">{contact.contact_email}</a>
                        </div>
                    ))}
                </div>
                
            </div>

            <div className="lg:py-12 pb-6 pt-4 max-w-6xl mx-auto flex flex-col lg:gap-12 gap-6 px-2">
                <h3 className="text-2xl pl-2">Or, leave us a message</h3>
                <div className="">

                    <form className="flex flex-col gap-4">
                        <div className="w-full flex flex-col lg:flex-row gap-4">
                            <input className="border p-3 w-full outline-none" placeholder="Name" />
                            <input className="border p-3 w-full outline-none" placeholder="Email" />
                        </div>
                        <input className="border p-4 outline-none" placeholder="Company Name" />
                        <div>
                            <textarea className="border p-3 w-full outline-none h-36" placeholder="Your Message"></textarea>
                        </div>
                        <button onClick={DisplayMessage} className="font-malaya text-md bg-[#1E2332] w-fit px-5 py-5 group relative hover:border-none tracking-widest text-xs font-bold">
                        {/*  */}
                            <div class="absolute inset-0 w-0 bg-[#E2B937] transition-all duration-300 ease-out group-hover:w-full"></div>
                            <span className="relative text-slate-50 group-hover:text-slate-50 uppercase">
                                Submit
                            </span>
                            
                        </button>
                    </form>

                </div>
            </div>
            
        </section>
    )
}